export const PUSH_INCOMING_TICKET = "PUSH_INCOMING_TICKET";
export const SET_INCOMING_TICKETS = "SET_INCOMING_TICKETS";
export const DELETE_INCOMING_TICKET = "DELETE_INCOMING_TICKET";
export const UPDATE_INCOMING_TICKET = "UPDATE_INCOMING_TICKET";
export const SET_SORTED_TICKETS = "SET_SORTED_TICKETS";
